<template>
    <div>
        <div class="room-type-container-xl">
            <div
                role="button"
                class="d-flex justify-content-between align-items-center"
                @click="toggleItem('roomType')"
            >
                <div class="d-flex align-items-center">
                    <img src="@/assets/services/vs/room-type-icon.svg" alt="" />

                    <div v-if="!expandRoomTypeMenu && selectedRoomTypes.length > 0" class="ms-3">
                        <span class="fsz-12 secondary-color">You choose </span>

                        <span v-if="selectedRoomTypes[0]" class="fsz-12 secondary-color">
                            <strong class="fw-bold accent-color fw-bold accent-color fsz-12">{{
                                selectedRoomTypes[0].name
                            }}</strong>

                            <span v-if="selectedRoomTypes[1]"> and </span>
                        </span>

                        <span v-if="selectedRoomTypes[1]" class="fsz-12 secondary-color">
                            <strong class="fw-bold accent-color fw-bold accent-color fsz-12"
                                >{{ selectedRoomTypes[1].name }}
                            </strong>

                            <span v-if="selectedRoomTypes[2]">and </span>
                        </span>

                        <span
                            v-if="selectedRoomTypes[2]"
                            class="fw-bold accent-color fw-bold accent-color fsz-12"
                        >
                            <strong>{{ selectedRoomTypes[2].name }}</strong>
                        </span>

                        <span class="fsz-12 secondary-color"> for Roomtype.</span>
                    </div>

                    <span v-else class="ms-3 fsz-12 primary-color"
                        >Choose Your <strong>Roomtype</strong> (Max. 3 Type)</span
                    >
                </div>

                <span>
                    <img
                        v-show="expandRoomTypeMenu"
                        src="@/assets/services/collapse-icon.svg"
                        alt=""
                    />

                    <img v-show="!expandRoomTypeMenu" src="@/assets/services/expand.svg" alt="" />
                </span>
            </div>

            <CollapseTransition>
                <div v-if="expandRoomTypeMenu" class="d-flex flex-wrap align-items-center mt-4">
                    <div
                        v-for="(category, index) in roomTypes"
                        :key="index"
                        :class="[roomtypeClass(category.id)]"
                        @click="selectRoomType(category)"
                    >
                        <img
                            v-show="handleFindIndex(category.id) >= 0"
                            src="@/assets/services/vs/tick.svg"
                            alt=""
                        />

                        <span> {{ category.name }}</span>
                    </div>
                </div>
            </CollapseTransition>
        </div>

        <div class="room-type-notification-container-xl">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notificationMessage"
                    :status="notificationStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import { mapGetters, mapState } from 'vuex';
import Notification from '@/components/snacks/index.vue';

export default {
    components: {
        CollapseTransition,
        Notification,
    },
    data() {
        return {
            // expandRoomTypeMenu: false,
            selectedId: [],
            showNotification: false,
            notificationMessage: '',
            notificationStatus: '',
        };
    },
    computed: {
        ...mapGetters(['roomTypes', 'selectedRoomTypes']),
        ...mapState({
            expandRoomTypeMenu: (state) => state.vsStore.expandRoomTypeMenu,
        }),
        categories() {
            return this.virtualStagingStore.catalogues;
        },
    },
    watch: {
        selectedId: function () {
            this.$store.commit('checkRoomTypeChanges', true);
        },
    },
    mounted() {
        this.selectedRoomTypes.map((item) => {
            this.selectedId.push(item.id);
        });
    },
    methods: {
        toggleItem(type) {
            // this.expandRoomTypeMenu = !this.expandRoomTypeMenu;
            this.$store.commit('HANDLE_TOGGLE_ROOMETYPE',type);
        },
        roomtypeClass(id) {
            if (this.handleFindIndex(id) >= 0) {
                return 'room-type-item-active-xl';
            }
            if (this.selectedRoomTypes.length > 2) {
                return 'room-type-item-inactive-xl text-decoration-line-through';
            }
            return 'room-type-item-inactive-xl';
        },
        selectRoomType(roomType) {
            let payload = {};
            if (this.handleFindIndex(roomType.id) < 0) {
                if (this.selectedRoomTypes.length > 2) {
                    this.showNotification = true;
                    this.notificationStatus = 'warning';
                    this.notificationMessage = 'You can not select more than three options';
                    setTimeout(() => {
                        this.showNotification = false;
                    }, 3000);
                    return;
                }
                payload.type = 'add';
                payload.roomType = roomType;
                this.$store.commit('HANDLE_SELECTED_ROOMTYPE', payload);
                return;
            }
            payload.type = 'remove';
            payload.roomType = roomType;
            payload.roomTypeIndex = this.handleFindIndex(roomType.id);
            this.$store.commit('HANDLE_SELECTED_ROOMTYPE', payload);
        },
        handleFindIndex(id) {
            const roomTypeIndex = this.selectedRoomTypes.findIndex((roomtype) => {
                return roomtype.id === id;
            });
            return roomTypeIndex;
        },
    },
};
</script>

<style lang="scss" scoped>
.room-type {
    &-container-xl {
        border: 2px solid #ededed;
        border-radius: 16px;
        padding: 16px 24px;
    }
    &-item {
        &-inactive-xl {
            border: 1px solid $Third-Text-Color;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: fit-content;
            height: 32px;
            font-size: 14px;
            border-radius: 32px;
            margin-right: 24px;
            text-align: center;
            padding: 0 12px;
            margin-bottom: 16px;
            color: $Primary-Text-Color;
            cursor: pointer;
            img {
                margin-top: 10px;
            }
        }
        &-active-xl {
            background-color: rgba($color: #707ac9, $alpha: 0.2); // display: flex;
            // align-items: center;
            // flex-wrap: wrap;
            // width: fit-content;
            height: 32px;
            font-size: 14px;
            border-radius: 32px;
            margin-right: 24px;
            text-align: center;
            padding: 0 12px;
            margin-bottom: 16px;
            color: $Accent-Color;
            font-weight: bold;
            cursor: pointer;
            img {
                margin-top: 10px;
            }
        }
    }
    &-notification {
        &-container-xl {
            position: fixed;
            bottom: 20px;
            right: 20px;
            z-index: 10;
        }
    }
}
</style>
